import { __decorate, __metadata } from "tslib";
import { AppRequest } from '@core/shared/app-request';
import { AppRequestMethod } from '@core/shared/request';
import { Expose, Model, ModelId } from '@core/shared/model';
let GenerateMediaAssetSubtitlesResponse = /*#__PURE__*/(() => {
  let GenerateMediaAssetSubtitlesResponse = class GenerateMediaAssetSubtitlesResponse extends Model {};
  GenerateMediaAssetSubtitlesResponse = __decorate([ModelId("GenerateMediaAssetSubtitlesResponse") // auto-generated by generate-model-ids
  ], GenerateMediaAssetSubtitlesResponse);
  return GenerateMediaAssetSubtitlesResponse;
})();
export { GenerateMediaAssetSubtitlesResponse };
let GenerateMediaAssetSubtitlesRequest = /*#__PURE__*/(() => {
  let GenerateMediaAssetSubtitlesRequest = class GenerateMediaAssetSubtitlesRequest extends Model {
    static {
      this.Response = GenerateMediaAssetSubtitlesResponse;
    }
  };
  __decorate([Expose(), __metadata("design:type", Number)], GenerateMediaAssetSubtitlesRequest.prototype, "assetId", void 0);
  GenerateMediaAssetSubtitlesRequest = __decorate([AppRequest('media', 'assets/generate-subtitles', {
    httpMethod: AppRequestMethod.POST,
    simpleAbilityCheck: 'ADMINISTRATOR'
  }), ModelId("GenerateMediaAssetSubtitlesRequest") // auto-generated by generate-model-ids
  ], GenerateMediaAssetSubtitlesRequest);
  return GenerateMediaAssetSubtitlesRequest;
})();
export { GenerateMediaAssetSubtitlesRequest };